import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

declare module 'pdfmake/build/pdfmake';
declare module 'pdfmake/build/vfs_fonts';

const anyPdfMake: any = pdfMake as any;
const anyFonts: any = pdfFonts as any;

anyPdfMake.vfs = anyFonts?.pdfMake?.vfs ?? anyFonts?.vfs;

export default pdfMake;
